// import React, { Component, Fragment, useEffect, useState } from 'react'
// import green from "@material-ui/core/colors/green";

import { fade } from '@material-ui/core'

const drawerWidth = 240

const useStyles = (theme) => ({
  large: {
    display: 'flex',
    justifyContent: 'center',
    width: theme.spacing(27),
    height: theme.spacing(27),
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
  },
  paper: {
    background: '#fff',

    width: '50vw',
    // height: '15vw',
    margin: 'auto',
    padding: '2%',
  },
  formControl: {
    width: 260,
  },

  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
})

export { useStyles }
